import { Component } from '@angular/core';

@Component({
    selector: 'app-dynamic-data-list-header',
    templateUrl: './dynamic-data-list-header.component.html',
    standalone: false
})
export class DynamicDataListHeaderComponent {}
